import React from 'react';
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';
import {
  maxValueMonetario,
  minValueMonetario,
  renderFieldCheck,
  renderFieldMonetarioFormulario,
  renderFieldNumeros,
  renderFieldText,
  required,
} from '../../util/inputs';
import Autorizacao from '../../security/Autorizacao';
import {getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, getVendedorEmpresa, PERFIL_ADMIN} from '../../security/securityContext';
import alterarFormaPagamentoPedido from '../../actions/pedido/alterarFormaPagamentoPedido';
import {realParaNumber} from '../../util/numberUtil';
import {tamanhoArquivoUpload} from '../../util/applicationContext';
import {showErrorMsg, showSuccessMsg} from '../../util/messagesUtil';

export class ModalAlterarFormaPagamento extends React.Component {
  constructor (props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  fecharModal () {
    $('#modalAlterarFormaPagamento')
      .modal('hide');
    $('#modalAlterarFormaPagamento')
      .hide();
    $('.modal-backdrop')
      .hide();
    this.props.reset('formAlterarFormaPagamento')
  }

  submit (values) {
    const pagamento = [];
    if (values.cartao) {
      pagamento.push({
        tipo: 'Cartão',
        codigoTipo: 'CARTAO',
        base64Comprovante: values.base64Comprovante,
        numeroComprovante: values.numeroComprovante,
        valor: realParaNumber(values.valorCartao.toString()),
        quantidadeParcelas: values.quantidadeParcelas,
        nomeComprovante: values.nomeComprovante,
        urlComprovante: values.urlComprovante
      })
    }

    if (values.dinheiro) {
      pagamento.push({
        tipo: 'Dinheiro',
        codigoTipo: 'DINHEIRO',
        base64Comprovante: '',
        numeroComprovante: '',
        valor: realParaNumber(values.valorDinheiro),
        quantidadeParcelas: 1
      })
    }

    if (values.pix) {
      pagamento.push({
        tipo: 'PIX',
        codigoTipo: 'PIX',
        base64Comprovante: values.base64ComprovantePIX,
        numeroComprovante: values.numeroComprovantePIX,
        valor: realParaNumber(values.valorPIX.toString()),
        quantidadeParcelas: 1,
        nomeComprovante: values.nomeComprovantePIX,
        urlComprovante: values.urlComprovantePIX
      })
    }

    const alterarFormaPagamento = {
      formasPagamento: pagamento,
      empresaId: this.props.empresaSelecionada.id,
      pedidoId: this.props.pedido.id

    };

    this.props.alterarFormaPagamentoPedido(alterarFormaPagamento)
      .then(() => {
          showSuccessMsg('Forma de pagamento alterada com sucesso');
          this.fecharModal();
          this.props.buscarPedidos();
      })
  }

  handleChange (event) {
    const file = event.target.files[0];
    if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
      return
    }
    if (file.size > tamanhoArquivoUpload) {
      showErrorMsg('Tamanho do arquivo excede 20 MB');
      return
    }
    this.converterParaBase64(file, 'CARTAO')
  }

  handleChangePix (event) {
    const file = event.target.files[0];
    if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
      return
    }
    if (file.size > tamanhoArquivoUpload) {
      showErrorMsg('Tamanho do arquivo excede 20 MB');
      return
    }
    this.converterParaBase64(file, 'PIX')
  }

  converterParaBase64 (file, formaPagamento) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      if(formaPagamento === 'PIX') {
        this.props.changeFieldValue('formAlterarFormaPagamento',
          'base64ComprovantePIX', reader.result);
        this.props.changeFieldValue('formAlterarFormaPagamento',
          'nomeComprovantePIX', file.name);
      } else {
        this.props.changeFieldValue('formAlterarFormaPagamento',
          'base64Comprovante', reader.result);
        this.props.changeFieldValue('formAlterarFormaPagamento',
          'nomeComprovante', file.name);
      }
    }.bind(this);
  }

  limparFormulario () {
    this.props.reset('formAlterarFormaPagamento');
    this.removerArquivo();
  }

  exibirAnexar () {
    if (this.props.base64Comprovante || this.props.urlComprovante) {
      return (
        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
          getGestorEmpresa(this.props.empresaSelecionada.id),
          getAdminEmpresa(this.props.empresaSelecionada.id),
          getOperadorEmpresa(this.props.empresaSelecionada.id),
          getVendedorEmpresa(this.props.empresaSelecionada.id)
        ]}>
          <div className="row align-items-center mt-2">
            <div className='col-12 label-cancelamento'>
              <label>Comprovante Cartão:</label>
            </div>
            <div className='ml-4'>{this.props.nomeComprovante}</div>
            {this.exibirRemoverComprovante('CARTAO')}
            {this.exibirBaixarComprovante()}
          </div>
        </Autorizacao>)
    }
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
        getGestorEmpresa(this.props.empresaSelecionada.id),
        getAdminEmpresa(this.props.empresaSelecionada.id),
        getOperadorEmpresa(this.props.empresaSelecionada.id),
        getVendedorEmpresa(this.props.empresaSelecionada.id)
      ]}>
        <div className='input-wrapper mt-3'>
          <label className='btn-laranja' htmlFor='input-file'>
            <div className='row align-items-center'>
              <i className="material-icons aberto">&#xe2c3;</i>
              <strong className='ml-2'>Anexar comprovante de pagamento</strong>
            </div>
          </label>
          <input id='input-file' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                 onChange={this.handleChange.bind(this)}/>
        </div><label style={{ fontSize: 'smaller' }}>
        * Tamanho máximo permitido : 20 MB
      </label>

      </Autorizacao>)
  }

  exibirAnexarPix () {
    if (this.props.base64ComprovantePIX || this.props.urlComprovantePIX) {
      return (
        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
          getGestorEmpresa(this.props.empresaSelecionada.id),
          getAdminEmpresa(this.props.empresaSelecionada.id),
          getOperadorEmpresa(this.props.empresaSelecionada.id),
          getVendedorEmpresa(this.props.empresaSelecionada.id)
        ]}>
          <div className="row align-items-center mt-2">
            <div className='col-12 label-cancelamento'>
              <label>Comprovante PIX:</label>
            </div>
            <div className='ml-4'>{this.props.nomeComprovantePIX}</div>
            {this.exibirRemoverComprovante('PIX')}
            {this.exibirBaixarComprovantePix()}
          </div>
        </Autorizacao>)
    }
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
        getGestorEmpresa(this.props.empresaSelecionada.id),
        getAdminEmpresa(this.props.empresaSelecionada.id),
        getOperadorEmpresa(this.props.empresaSelecionada.id),
        getVendedorEmpresa(this.props.empresaSelecionada.id)
      ]}>
        <div className='input-wrapper mt-3'>
          <label className='btn-laranja' htmlFor='input-file'>
            <div className='row align-items-center'>
              <i className="material-icons aberto">&#xe2c3;</i>
              <strong className='ml-2'>Anexar comprovante de pagamento</strong>
            </div>
          </label>
          <input id='input-file' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                 onChange={this.handleChangePix.bind(this)}/>
        </div><label style={{ fontSize: 'smaller' }}>
        * Tamanho máximo permitido : 20 MB
      </label>

      </Autorizacao>)
  }

  exibirBaixarComprovante () {
    if (this.props.urlComprovante) {
      return (<Autorizacao perfisPermitidos={[PERFIL_ADMIN,
        getGestorEmpresa(this.props.empresaSelecionada.id),
        getAdminEmpresa(this.props.empresaSelecionada.id),
        getOperadorEmpresa(this.props.empresaSelecionada.id),
        getVendedorEmpresa(this.props.empresaSelecionada.id)
      ]}>
        <button type="button" className="btn btn-editar"
                title='Baixar'
                onClick={() => window.open(this.props.urlComprovante, '_blank')}>
          <i className="material-icons nav-icon" style={{
            color: '#fa8d42'
          }}>&#xe2c0;</i>
        </button>
      </Autorizacao>)
    }
  }

  exibirBaixarComprovantePix() {
    if (this.props.urlComprovantePIX) {
      return (<Autorizacao perfisPermitidos={[PERFIL_ADMIN,
        getGestorEmpresa(this.props.empresaSelecionada.id),
        getAdminEmpresa(this.props.empresaSelecionada.id),
        getOperadorEmpresa(this.props.empresaSelecionada.id),
        getVendedorEmpresa(this.props.empresaSelecionada.id)
      ]}>
        <button type="button" className="btn btn-editar"
                title='Baixar'
                onClick={() => window.open(this.props.urlComprovantePIX, '_blank')}>
          <i className="material-icons nav-icon" style={{
            color: '#fa8d42'
          }}>&#xe2c0;</i>
        </button>
      </Autorizacao>)
    }
    return '';
  }

  exibirRemoverComprovante (formaPagamento) {
    return (<Autorizacao perfisPermitidos={[PERFIL_ADMIN,
      getAdminEmpresa(this.props.empresaSelecionada.id),
      getGestorEmpresa(this.props.empresaSelecionada.id),
      getOperadorEmpresa(this.props.empresaSelecionada.id),
      getVendedorEmpresa(this.props.empresaSelecionada.id)
    ]}>
      <button type="button" className="btn btn-editar"
              title='Remover'
              onClick={() => this.removerArquivo(formaPagamento)}>
        <i className="material-icons nav-icon" style={{
          color: 'red'
        }}>&#xe14c;</i>
      </button>
    </Autorizacao>)
  }

  removerArquivo (formaPagamento) {
    if(formaPagamento === 'PIX') {
      this.props.changeFieldValue('formAlterarFormaPagamento',
      'base64ComprovantePIX', null);
    this.props.changeFieldValue('formAlterarFormaPagamento',
      'nomeComprovantePIX', '');
    this.props.changeFieldValue('formAlterarFormaPagamento',
      'urlComprovantePIX', null);
    } else {
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'base64Comprovante', null);
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'nomeComprovante', '');
      this.props.changeFieldValue('formAlterarFormaPagamento',
        'urlComprovante', null);
    }
  }

  handleCheckDinheiro () {
    this.props.changeFieldValue('formAlterarFormaPagamento',
      'dinheiro', !this.props.dinheiro);
  }

  handleCkeckCartao () {
    this.props.changeFieldValue('formAlterarFormaPagamento',
      'cartao', !this.props.cartao);
  }

  handleCkeckPix () {
    this.props.changeFieldValue('formAlterarFormaPagamento',
      'pix', !this.props.pix);
  }

  // eslint-disable-next-line class-methods-use-this
  exibirBotoesVendedor (invalid, submitting, pristine) {
    return (
      <div className="modal-footer">
        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
          getAdminEmpresa(this.props.empresaSelecionada.id),
          getGestorEmpresa(this.props.empresaSelecionada.id),
          getOperadorEmpresa(this.props.empresaSelecionada.id),
          getVendedorEmpresa(this.props.empresaSelecionada.id)
        ]}>
          <button type="submit" className="btn btn-laranja" id="btn-confirmar-acesso-autos" disabled={invalid || submitting || pristine}>
            ENVIAR
          </button>
        </Autorizacao>
      </div>)
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;

    return (
      <div className="modal fade show" role="dialog"
           id="modalAlterarFormaPagamento" aria-labelledby="modalAlterarFormaPagamento" aria-hidden="true"
           data-backdrop="static">
        <div className="modal-dialog modal-info modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">Pedido {this.props.pedido ? this.props.pedido.id : ''}</h3>
              <button type="button" className="close" data-dismiss="modal" id="btnFecharModalAlterarFormaPagamento"
                      onClick={() => this.limparFormulario()}
                      aria-label="Close">
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            <form onSubmit={handleSubmit(this.submit)}>
              <div className="modal-body corpo-modal">
                <Field name="cartao" type="checkbox" component={renderFieldCheck} label="Cartão"
                       css="form-check-input" readOnly={false}
                       onChange={() => this.handleCkeckCartao()}/>
                {this.props.cartao ? <div>
                  <div className="form-group">
                    {this.exibirAnexar()}
                  </div>
                  <div className="form-group">
                    <Field name="numeroComprovante" type="text" component={renderFieldText}
                           css="form-control col-md-6" label="Número comprovante:"/>
                  </div>
                  <div className="form-group">
                    <Field name="quantidadeParcelas" type="text" component={renderFieldNumeros}
                           label="Quantidade de parcelas:" valor={this.props.quantidadeParcelas}
                           css="form-control col-md-2" readOnly={false}/>
                  </div>
                  <div className="form-group">
                    <Field name="valorCartao" type="text" validate={[required, maxValueMonetario, minValueMonetario]} component={renderFieldMonetarioFormulario}
                           css="form-control col-md-3" label="Valor em cartão"/>
                  </div>


                </div> : ''
                }
                <Field name="pix" type="checkbox" component={renderFieldCheck} label="PIX"
                       css="form-check-input" readOnly={false}
                       onChange={() => this.handleCkeckPix()}/>
                {this.props.pix ? <div>
                  <div className="form-group">
                    {this.exibirAnexarPix()}
                  </div>
                  <div className="form-group">
                    <Field name="numeroComprovantePIX" type="text" component={renderFieldText}
                           css="form-control col-md-6" label="Número comprovante PIX:"/>
                  </div>
                  <div className="form-group">
                    <Field name="valorPIX" type="text" validate={[required, maxValueMonetario, minValueMonetario]} component={renderFieldMonetarioFormulario}
                           css="form-control col-md-3" label="Valor em PIX"/>
                  </div>


                </div> : ''
                }
                <Field name="dinheiro" type="checkbox" component={renderFieldCheck} label="Dinheiro"
                       css="form-check-input" readOnly={false} onChange={() => this.handleCheckDinheiro()}/>
                {this.props.dinheiro ? <div>
                  <div className="form-group">
                    <Field name="valorDinheiro" type="text" validate={[required, maxValueMonetario, minValueMonetario]} component={renderFieldMonetarioFormulario}
                           css="form-control col-md-3" label="Valor em dinheiro"/>
                  </div>
                </div> : ''}
                <Field name="valorTotal" type="text" readOnly={true} component={renderFieldMonetarioFormulario}
                       css="form-control col-md-4 mb-2" label="Valor total do pedido"/>
                {this.exibirBotoesVendedor(invalid, submitting, pristine)}
              </div>
            </form>
          </div>
        </div>
      </div>

    )
  }
}

const seletor = formValueSelector('formAlterarFormaPagamento');

export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
    pedido: state.pedido,
    itemFechamento: state.itemFechamento,
    nomeComprovante: seletor(state, 'nomeComprovante'),
    urlComprovante: seletor(state, 'urlComprovante'),
    base64Comprovante: seletor(state, 'base64Comprovante'),
    quantidadeParcelas: seletor(state, 'quantidadeParcelas'),
    nomeComprovantePIX: seletor(state, 'nomeComprovantePIX'),
    urlComprovantePIX: seletor(state, 'urlComprovantePIX'),
    base64ComprovantePIX: seletor(state, 'base64ComprovantePIX'),
    dinheiro: seletor(state, 'dinheiro'),
    cartao: seletor(state, 'cartao'),
    pix: seletor(state, 'pix')
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    alterarFormaPagamentoPedido
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formAlterarFormaPagamento',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(ModalAlterarFormaPagamento));
